module.exports = __webpack_public_path__ + "media/images/service/c_10-3b08b09336cef57506ff46caa2ca5fbf.png";